import { Link } from 'react-router-dom'

const LABEL = "Create My Account — It's Free"
/** The hero offers the 1-month-free early-access deal, which is gated behind
 *  the waitlist form rather than plain signup — so it keeps the old wording. */
const WAITLIST_LABEL = "Secure My Spot — It's Free"

type Props = {
  className?: string
  variant?: 'hero' | 'cta' | 'nav'
  /** Renders a plain button instead of a Link to "/signup" — for use as an ExpandableScreenTrigger child. */
  asTrigger?: boolean
  /** Overrides the button text. Defaults to the account-creation wording. */
  label?: string
}

export default function BetaLaunchLink({ className = '', variant = 'hero', asTrigger = false, label = LABEL }: Props) {
  const base =
    variant === 'hero'
      ? 'group relative px-12 py-5 md:text-[1.25rem] bg-accent text-black font-bold rounded-full overflow-hidden transition-all hover:bg-transparent hover:text-accent hover:scale-105 shadow-[0_0_30px_rgba(60,180,79,0.3)] hover:shadow-[0_0_50px_rgba(60,180,79,0.4)]'
      : variant === 'cta'
        ? 'bg-[#1C1C1C] text-[#3cb44f] px-8 py-3.5 rounded-full text-lg font-medium hover:bg-[#3cb44f] hover:text-black border cursor-pointer transition-colors duration-300 inline-block text-center'
        : 'px-8 cursor-pointer py-3 bg-accent border border-white/10 rounded-full text-[11px] font-black uppercase tracking-[.25em] text-black hover:bg-black hover:text-accent hover:border-accent transition-colors duration-300'

  const content = (
    <>
      {variant === 'hero' && (
        <span className="absolute inset-0 bg-white/20 translate-y-full transition-transform duration-300" />
      )}
      <span className={variant === 'hero' ? 'relative flex items-center justify-center gap-2' : ''}>
        {label}
      </span>
    </>
  )

  const linkElement = asTrigger ? (
    <button type="button" className={`${base} ${className}`.trim()}>
      {content}
    </button>
  ) : (
    <Link
      to="/signup"
      className={`${base} ${className}`.trim()}
    >
      {content}
    </Link>
  )

  // As a trigger, only the bare button is returned — the caller (e.g. inside
  // ExpandableScreenTrigger) owns the surrounding layout so the layoutId
  // morph animates from just the button, not the button + subtext block.
  if (asTrigger) {
    return linkElement
  }

  if (variant === 'hero') {
    return (
      <div className="flex flex-col items-center gap-4 mt-2">
        {linkElement}
        <span className="text-xs sm:text-sm text-slate-400/80 font-medium tracking-wide">
          Joining freelancers from India...
        </span>
      </div>
    )
  }

  if (variant === 'cta') {
    return (
      <div className="flex flex-col items-center gap-4 mt-2">
        {linkElement}
        <span className="text-xs sm:text-sm text-slate-900/80 font-medium tracking-wide">
          Joining freelancers from India...
        </span>
      </div>
    )
  }

  return linkElement
}

export { LABEL as BETA_LAUNCH_LABEL, WAITLIST_LABEL }
